define('ANSI/UIComponents/SlickSliderExtended',['jquery', 'slick'], function ($) {
    function SlickSlider(scope, args) {
        Object.defineProperty(this, 'scope', { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, '$scope', { enumerable: !0, value: $(scope) });
        Object.defineProperty(this, 'lastDirection', { enumerable: !1, value: void 0, writable: !0 });

        var fade = $(scope).hasClass('slide-fade') || false;

        var settings = {
            autoplay: args.Speed > 0,
            autoplaySpeed: args.Speed,
            slidesToShow: args.SlidesToShow || 1,
            slidesToScroll: args.SlidesToScroll || 1,

            // defaults
            dots: true,
            responsive: [],

            // extensions
            fade: fade
        };

        if (args.ResponsiveDisplay) {
            var breakpointsArray = [];
            args.ResponsiveDisplay.split('|').forEach(function (kvp) {
                var breakpointValue = kvp.split('=')[0];
                var slidesToShowCount = kvp.split('=')[1];
                var breakpoint = {
                    breakpoint: breakpointValue,
                    settings: {
                        slidesToShow: slidesToShowCount,
                        slidesToScroll: Math.min(args.SlidesToScroll, slidesToShowCount)
                    }
                };

                breakpointsArray.push(breakpoint);
            });

            settings.responsive.push(breakpointsArray);
        }

        var slickSlider = this.$scope.slick(settings)[0].slick;
        Object.defineProperty(this, 'slider', { enumerable: !0, value: slickSlider, writable: !1, configurable: !0 });

        slickSlider.slideHandler = this._captureDirection.bind(this, slickSlider, slickSlider.slideHandler);
        this.$scope.on('afterChange', this._onAfterChangeSlide.bind(this));
        this.$scope.on('beforeChange', this._onBeforeChangeSlide.bind(this));
    }

    /**
     * Capture slider direction, it can be done only with raw parameters received in slideHandler function.
     * @param {} slider an instance of a slider, to run the original function in a context of it
     * @param {} baseFn a reference to the original slideHandler function
     * @param {} index unmodified index number, to understand direction
     * @returns {}
     */
    SlickSlider.prototype._captureDirection = function (slider, baseFn, index) {
        this.lastDirection = index > slider.currentSlide ? 'left' : 'right';
        baseFn.apply(slider, Array.prototype.slice.call(arguments, 2));
    };

    /**
     * Notify the world about slide is going to be changed
     */
    SlickSlider.prototype._onBeforeChangeSlide = function () {
        $(this).trigger('beforeChange.slider', [this, this.lastDirection]);
    };

    /**
     * Notify the world about slide was changed
     * @param {jQuery.Event} event from bootstrap carousel
     */
    SlickSlider.prototype._onAfterChangeSlide = function () {
        $(this).trigger('afterChange.slider', [this, this.lastDirection]);
    };

    SlickSlider.init = function (args) {
        if (args.IsEditorEditing) return null;

        var slick = new SlickSlider(args.scope, args);

        return slick;
    };

    return SlickSlider;
});

